import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import pipelineLogo from "@/assets/pipeline-dreams-logo.webp";

const Footer = () => (
  <footer className="border-t border-border/50 bg-background/90 backdrop-blur-xl py-12 relative overflow-hidden">
    {/* Subtle cosmic gradient overlay */}
    <div className="absolute inset-0 bg-gradient-to-t from-[hsl(260,60%,8%)] to-transparent opacity-60 pointer-events-none" />
    <div className="container mx-auto px-4 relative z-10">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-2">
          <Sparkles className="w-5 h-5 text-cosmic-gold" />
          <span className="font-display text-lg font-bold">Nebula</span>
        </div>
        <div className="flex gap-6 text-sm text-muted-foreground">
          <Link to="/about" className="hover:text-foreground transition-colors">About</Link>
          <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-foreground transition-colors">Terms</Link>
          <Link to="/contact" className="hover:text-foreground transition-colors">Contact</Link>
        </div>
      </div>
      <div className="mt-10 flex flex-col items-center gap-3 border-t border-border/30 pt-8">
        <img src={pipelineLogo} alt="Pipeline Dreams" className="h-12 w-auto" width={48} height={48} loading="lazy" />
        <p className="text-sm font-medium bg-gradient-to-r from-[hsl(180,100%,50%)] to-[hsl(280,100%,65%)] bg-clip-text text-transparent">
          Built and powered by Pipeline Dreams AI Labs
        </p>
        <p className="text-xs text-muted-foreground/60">© {new Date().getFullYear()} All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
